module.exports = __webpack_public_path__ + "img/max-file-content-image-sync.a5672e0f.svg";